export const environment = {
  production: true,
  protocolsApiUrl: 'https://api.release.getlilo.io/protocols',
  authorizationApiUrl: 'https://api.release.getlilo.io/login',
};
